module.exports = __webpack_public_path__ + "img/4fd8840eadac1c9a385f216a3f1c246e.png";